define("shared/components/shared/wizard/slide", ["exports", "@ember/component", "@ember/object", "@glimmer/component", "shared/utils/uuid", "@ember/template-factory"], function (_exports, _component, _object, _component2, _uuid, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@glimmer/component",0,"shared/utils/uuid",0,"@ember/component"eaimeta@70e063a35619d71f
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{#if this.isActive}}
    {{#if (has-block)}}
      {{#let
        (hash
          cancel=(component "shared/wizard/cancel-button" isFirstSlide=@isFirstSlide)
          next=(component "shared/wizard/next-button" nextSlide=(action "nextSlide"))
          previous=(component "shared/wizard/previous-button" previousSlide=(action "previousSlide"))
          finish=(component "shared/wizard/finish-button" isLastSlide=@isLastSlide finishWizard=(action @finishWizard))
        )
        as |buttons|
      }}
  
        <@modal.card @portrait={{@portrait}} @primaryClass={{this.primaryClass}}>
          {{yield
            (hash
              header=(component "shared/wizard/slide/header" modal=@modal)
              body=(component "shared/wizard/slide/body" modal=@modal)
              nextButton=buttons.next
              nextSlide=(action "nextSlide")
              previousButton=buttons.previous
              cancelButton=buttons.cancel
              finishButton=buttons.finish
              slideCount=(component "shared/wizard/slide-count" slideProgressString=@slideProgressString)
              footer=(component
                "shared/wizard/slide/footer"
                modal=@modal
                cancelButton=buttons.cancel
                nextButton=buttons.next
                previousButton=buttons.previous
                finishButton=buttons.finish
                finishWizard=(action @finishWizard)
                isLastSlide=@isLastSlide
                isFirstSlide=@isFirstSlide
                slideCount=(component "shared/wizard/slide-count" slideProgressString=@slideProgressString)
              )
            )
          }}
        </@modal.card>
      {{/let}}
    {{/if}}
  {{/if}}
  */
  {
    "id": "44gLp1zc",
    "block": "[[[41,[30,0,[\"isActive\"]],[[[41,[48,[30,8]],[[[44,[[28,[37,3],null,[[\"cancel\",\"next\",\"previous\",\"finish\"],[[50,\"shared/wizard/cancel-button\",0,null,[[\"isFirstSlide\"],[[30,1]]]],[50,\"shared/wizard/next-button\",0,null,[[\"nextSlide\"],[[28,[37,5],[[30,0],\"nextSlide\"],null]]]],[50,\"shared/wizard/previous-button\",0,null,[[\"previousSlide\"],[[28,[37,5],[[30,0],\"previousSlide\"],null]]]],[50,\"shared/wizard/finish-button\",0,null,[[\"isLastSlide\",\"finishWizard\"],[[30,2],[28,[37,5],[[30,0],[30,3]],null]]]]]]]],[[[1,\"\\n      \"],[8,[30,5,[\"card\"]],null,[[\"@portrait\",\"@primaryClass\"],[[30,6],[30,0,[\"primaryClass\"]]]],[[\"default\"],[[[[1,\"\\n        \"],[18,8,[[28,[37,3],null,[[\"header\",\"body\",\"nextButton\",\"nextSlide\",\"previousButton\",\"cancelButton\",\"finishButton\",\"slideCount\",\"footer\"],[[50,\"shared/wizard/slide/header\",0,null,[[\"modal\"],[[30,5]]]],[50,\"shared/wizard/slide/body\",0,null,[[\"modal\"],[[30,5]]]],[30,4,[\"next\"]],[28,[37,5],[[30,0],\"nextSlide\"],null],[30,4,[\"previous\"]],[30,4,[\"cancel\"]],[30,4,[\"finish\"]],[50,\"shared/wizard/slide-count\",0,null,[[\"slideProgressString\"],[[30,7]]]],[50,\"shared/wizard/slide/footer\",0,null,[[\"modal\",\"cancelButton\",\"nextButton\",\"previousButton\",\"finishButton\",\"finishWizard\",\"isLastSlide\",\"isFirstSlide\",\"slideCount\"],[[30,5],[30,4,[\"cancel\"]],[30,4,[\"next\"]],[30,4,[\"previous\"]],[30,4,[\"finish\"]],[28,[37,5],[[30,0],[30,3]],null],[30,2],[30,1],[50,\"shared/wizard/slide-count\",0,null,[[\"slideProgressString\"],[[30,7]]]]]]]]]]]],[1,\"\\n      \"]],[]]]]],[1,\"\\n\"]],[4]]]],[]],null]],[]],null]],[\"@isFirstSlide\",\"@isLastSlide\",\"@finishWizard\",\"buttons\",\"@modal\",\"@portrait\",\"@slideProgressString\",\"&default\"],false,[\"if\",\"has-block\",\"let\",\"hash\",\"component\",\"action\",\"yield\"]]",
    "moduleName": "shared/components/shared/wizard/slide.hbs",
    "isStrictMode": false
  });
  let SlideComponent = _exports.default = (_class = class SlideComponent extends _component2.default {
    /**
     * Defines whether or not a slide is currently
     * active in the wizard
     *
     * @property isActive
     * @type {Boolean}
     */
    get isActive() {
      return this.args.activeSlideId === this.uniqueId;
    }
    get primaryClass() {
      return this.args.primaryClass ?? 'o--modalCard';
    }

    /**
     * Initializes Component, binds `this` to registerSlide
     *
     * @method init
     * @type {String}
     */
    constructor() {
      super(...arguments);
      _defineProperty(this, "uniqueId", (0, _uuid.default)());
      if (this.args.registerSlide) {
        this.args.registerSlide(this);
      }
      if (typeof this.args.id !== 'undefined') {
        this.uniqueId = this.args.id;
      }
    }
    nextSlide() {
      if (this.args.nextSlideFn) {
        this.args.nextSlide(this.args.nextSlideFn());
      } else {
        this.args.nextSlide();
      }
    }
    previousSlide() {
      if (this.args.previousSlideFn) {
        this.args.previousSlide(this.args.previousSlideFn());
      } else {
        this.args.previousSlide();
      }
    }
  }, (_applyDecoratedDescriptor(_class.prototype, "nextSlide", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "nextSlide"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "previousSlide", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "previousSlide"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, SlideComponent);
});